<script>
import ResourceList from '../../lib/components/ResourceList.vue';
import ScoreSetSelector from '../../lib/components/Selectors/ScoreSetSelector.vue';
import Archiver from '../../lib/components/ListActions/Archiver.vue';
import Unarchiver from '../../lib/components/ListActions/Unarchiver.vue';
import ListAction from '../../lib/components/ListActions/ListAction.vue';
import Tagger from '../../lib/components/ListActions/Tagger.vue';
import FundAllocator from "../../lib/components/ListActions/FundAllocator";

export default {
  components: {
    ScoreSetSelector,
    Archiver,
    Unarchiver,
    ListAction,
    Tagger,
    FundAllocator
  },
  extends: ResourceList,
  computed: {
    taggerRevealed() {
      return this.reveal === 'tagger';
    },
    fundAllocatorRevealed() {
      return this.reveal === 'fund-allocator';
    }
  }
};
</script>
